import React from 'react';
import { Login } from 'components/Login';

export default (props) => <Login {...props} />;
